const ProgrammeSearchReducer = (
  state = {
    isActive: false,
  },
  action = {},
) => {
  switch (action.type) {
    case 'TOGGLE_SEARCH': {
      return {
        ...state,
        isActive: !state.isActive,
      }
    }
    case 'CLOSE_SEARCH': {
      return {
        ...state,
        isActive: false,
      }
    }
    case 'OPEN_SEARCH': {
      return {
        ...state,
        isActive: true,
      }
    }

    default:
      return state
  }
}

export default ProgrammeSearchReducer
